//painel-admin/src/pages/Login.js

import React, { useEffect, useState, lazy, Suspense } from "react";

import axios from "../axiosConfig";
import { Link, useLocation } from "react-router-dom";
import bgImage from "../assets/bg-login.jpg";
import logo from "../assets/tikpontos.png";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "./Login.css";

import AvisoCookies from "../components/AvisoCookies";


const ModalTermos = lazy(() => import("../components/ModalTermos"));


const Login = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [aceitouTermos, setAceitouTermos] = useState(false);
  const [mostrarModalTermos, setMostrarModalTermos] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const location = useLocation();
  const motivo = new URLSearchParams(location.search).get("motivo");


  useEffect(() => {
    if (motivo === "expirado") {
      import("react-toastify").then(({ toast }) => {
        toast.info("Sua sessão expirou. Faça login novamente.");
      });
    }
  }, [motivo]);
  
  

  

const handleLogin = async (e) => {
  e.preventDefault();
  setErro("");

  if (!aceitouTermos) {
    setErro("Você precisa aceitar os termos de uso para continuar.");
    return;
  }

  setLoading(true);

  try {
    if (!executeRecaptcha) {
      setErro("reCAPTCHA não está disponível.");
      setLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("login");

    const response = await axios.post("/login", {
      email: email.trim(),
      senha,
      recaptchaToken,
    });

    const { token, usuario } = response.data;

    if (!token || !usuario) {
      setErro("Resposta inválida do servidor.");
      return;
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    // ✅ Salva imediatamente antes de qualquer nova chamada autenticada
    localStorage.setItem("token", token);
    localStorage.setItem("usuario", JSON.stringify(usuario));

    // ✅ Só busca empresa para cliente com CNPJ vinculado
    if (usuario.tipo === "cliente" && usuario.cnpj_empresa) {
      try {
        const resEmpresa = await axios.get(`/empresas/cnpj/${usuario.cnpj_empresa}`);

        const usuarioAtualizado = {
          ...usuario,
          cep_empresa: resEmpresa.data?.cep || "01001-000",
        };

        localStorage.setItem("usuario", JSON.stringify(usuarioAtualizado));
      } catch (err) {
        console.warn("⚠️ Falha ao buscar empresa por CNPJ, usando fallback de SP", err);

        const usuarioAtualizado = {
          ...usuario,
          cep_empresa: "01001-000",
        };

        localStorage.setItem("usuario", JSON.stringify(usuarioAtualizado));
      }
    }

    const origem = localStorage.getItem("origem_login");

    if (usuario.tipo === "cliente") {
      if (origem === "evento") {
        localStorage.removeItem("origem_login");
      } else {
        window.location.href = "/painel-cliente";
      }
      return;
    }

    if (["admin", "financeiro", "comercial", "logistica"].includes(usuario.tipo)) {
      window.location.href = "/dashboard";
      return;
    }

    setErro("Tipo de usuário inválido.");
  } catch (error) {
    console.error("Erro ao tentar login:", error);

    if (error.response?.status === 429) {
      setErro(
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Muitas tentativas de login. Aguarde alguns minutos e tente novamente."
      );
      return;
    }

    if (error.response?.status === 403) {
      setErro(
        error.response?.data?.error ||
        "Não foi possível validar a segurança do acesso. Tente novamente."
      );
      return;
    }

    if (error.response?.status === 401) { 
            setErro(
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.response?.data?.mensagem ||
        "E-mail ou senha inválidos."
      );
      return; 
    }

    setErro("Não foi possível fazer login agora. Tente novamente em instantes.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-wrapper">
      <div className="login-left" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="login-top">
          <img src={logo} alt="Logo Tikpag" className="login-logo" />
        </div>
        <div className="login-conteudo">
          <div className="login-texto">
            <h1>Bem-vindo ao</h1>
            <h2>Portal de Pontos Tikpag</h2>
            <p>Gerencie suas operações e resgate recompensas!</p>
          </div>
        </div>
      </div>

      <div className="login-right">
        <form onSubmit={handleLogin} className="login-form">
          <h3>Login</h3>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            name="senha"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />

<div className="checkbox-termos">
  <input
    type="checkbox"
    id="termos"
    checked={aceitouTermos}
    onChange={(e) => setAceitouTermos(e.target.checked)}
  />
  <label htmlFor="termos">
    Eu li e aceito os{" "}
    <span
      className="link-termos"
      onClick={() => setMostrarModalTermos(true)}
    >
      Termos de uso
    </span>
  </label>
</div>





          <button type="submit" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>

          {erro && <p className="erro">{erro}</p>}

          <div className="login-links">
            <Link to="/cadastro">Criar conta</Link>
            <span> | </span>
            <Link to="/esqueci-senha">Esqueci a senha</Link>
          </div>
        </form>
      </div>

      {mostrarModalTermos && (
  <Suspense fallback={null}>
    <ModalTermos onClose={() => setMostrarModalTermos(false)} />
  </Suspense>
)}
 
 <AvisoCookies />

    </div>
  );
};

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function LoginWrapper() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      <Login />
    </GoogleReCaptchaProvider>
  );
}
